let constants = {
  apiServiceBaseUri: 'https://b2b.diamante.com.co/admin/frontend/web/index.php',
  apiServiceBaseUri2: 'https://b2b.diamante.com.co/admin/backend/web/index.php',
  config : {
    appName: 'DIAMANTE S.A.',
    appVersion: 1.0,
    home_url : '/app/home',
    env: {
      basePath: 'https://b2b.diamante.com.co/',
      apiEndPoint: 'https://b2b.diamante.com.co/admin/frontend/web/index.php'
    },
    captchaKey : '6LcjNHQUAAAAAPVDqOJeDyL2NUTJRutxtdkI5BsH',
    paths: {
      categoriesMenu: '/param/get-category-menu',
      categories: '/categoria-info/ver-categorias',
      category: '/categoria-info/ver-categoria?id=',
      categoryArbol: '/categoria-info/arbol-categoria?id=',
      categoryProducts: '/categoria-info/ver-productos-categoria?id=',
      categoryAttributes: '/categoria-info/ver-atributos-categoria-dos?id=',
      advancedAttributes: '/item-info/get-advanced-attributes',
      compoundAttributes: '/item-info/get-compounds-attributes?id=',
      productsByAdvancedSearch: '/item-info/products-by-advanced-search',
      featuredProducts: '/item-info/ver-productos-destacados',
      product: '/item-info/ver-producto?id=',
      compareProducts: '/item-info/comparar-productos?ids=',
      relatedProducts: '/item-info/ver-productos-relacionados?id=',
      searchProduct: '/item-info/buscar-producto?cadena=',
      searchProductAutocomplete: '/item-info/autocompletado-producto?cadena=',
      searchProductLength: '/item-info/buscar-producto-cantidad?cadena=',
      adavancedSearchProduct: '/item-info/busqieda-avanzada-producto',
      clonedProductPrice: '/item-info/obtener-precio-item-clonado',
      setFavoriteProduct: '/item-info/set-favorite-product',

      // Fast Search
      fastSearchFavoriteItems: '/item-info/get-favorite-items',
      fastSearchLastItemsBought: '/item-info/get-last-items-bought',

      newItems: '/item-info/get-new-items',
      bestSellerItems: '/item-info/ver-productos-mas-vendidos',
      salesItems: '/item-info/lista-items-en-oferta',
      salesItemsLength: '/item-info/total-items-en-oferta',

      // Location Paths
      countries: '/location/get-countries',
      states: '/location/get-states?countryId=',
      cities: '/location/get-cities?stateId=',
      location: '/location/get-location?ids=',
      locationBySearchText: '/location/get-location-by-search-text',

      // Mails
      mailContact: '/item-info/enviar-correo-contactenos',
      mailProductNotFound: '/item-info/enviar-correo-producto-no-encontrado',
      mailProductRecommended: '/item-info/enviar-correo-producto-recomendado',

      mailNewsletter: '/item-info/send-newsletter-register',

      // User
      recoverPassword: '/login/recover-password',
      userLogin: '/login/user-login',
      userLogout: '/login/user-logout',
      userRegister: '/login/user-register',
      validateEmail: '/login/validate-email',
      validateNumberId: '/login/validate-number-id-zona-de-pago',
      userUpdate: '/user/update-user',
      passwordUpdate: '/user/update-password',
      getUserInfo: '/user/user-info',
      thirdBySearchText: '/user/get-third-by-search-text',
      userRegisterPayZone :  '/login/user-register-pay-zone',

      // Contact
      getContactByIdentificationNumber: '/user/get-contact-by-identification-number',

      // Carrito
      addItemToCart: '/cart/agregar-item-canasta',
      getCart: '/cart/obtener-canasta?cartId=',
      deleteCart: '/cart/delete-cart',
      deleteItemFromCart: '/cart/eliminar-item-canasta',
      updateCommentCart: '/cart/update-comment-cart',
      updateCommentItemCart: '/cart/update-comment-item-cart',
      updateQuantityItemCart: '/cart/update-quantity-item-cart',
      saveCartOrderData: '/cart/save-cart-order-data',
      saveCartTunnelData: '/cart/save-cart-tunnel-data',
      getPointsOfSale: '/cart/points-of-sale',
      updateCityLocation: '/cart/update-city-location',
      updatePayMethod: '/cart/update-pay-method',
      updateDespachoPedido: '/cart/update-despacho-pedido',

      // Order
      payMethods: '/order/pay-methods',
      payMethod: '/order/pay-method?payMethodId=',
      saveOrder: '/order/save-order',
      getOrder: '/order/order',
      duplicateOrder: '/cart/duplicate-order',
      getPay: '/order/get-pay-info?idPedido=',
      getUserOrders: '/order/user-orders',
      getDashboardInfo: '/dashboard/dashboard-info',
      createCartTemplate: '/cart/create-cart-template',
      getUserCartTemplates: '/cart/get-cart-templates',
      getUserCartTemplate: '/cart/get-cart-template',
      duplicateCartTemplate: '/cart/duplicate-cart-template',
      deleteCartTemplate: '/cart/delete-cart-template',
      changeStatus: '/order/change-status',
      sincronizarPedido: '/order/sincronizar-erp',

      // Quotes
      updateOrder: '/order/update-order',
      replyQuotes: '/quotes/reply-order',
      sendCopyEmailOrder: '/order/send-copy-order',
      convertOrder: '/quotes/convert-order',
      getSummaryQuotes: '/quotes/summary-quotes',
      loadPricesForPriceList: '/quotes/load-prices-for-price-list',
      setLostQuote: '/quotes/set-lost-quote',


      // Enlistment
      createEnlistment: '/enlistment/create-enlistment',

      // Warranty
      searchWarranty: '/warranty/search-warranty',
      saveWarranty: '/warranty/save-warranty',

      // Banners
      getBanners: '/template/get-ads-info',

      // App params
      getParams: '/param/get-app-params',

      // Contact Locations
      getContactLocations: '/location/get-contact-locations',

      // Seller Client
      getSellerClients: '/login/get-seller-clients',
      getSellerClientThirds: '/login/get-client-thirds',
      getSellerClientOperatingCenters: '/login/get-client-operating-centers',
      setClientOperatingCenter: '/login/set-client-operating-center',
      getOperatingCentersByUser: '/login/get-operating-centes-by-user',

      // Edarvico: Busqueda de motobombas
      getUmCaudalPresion: '/item-curva/get-unidades-medida',
      getMotobombas: '/item-curva/buscar-items',
      getCategoriasBombas: '/item-curva/get-categorias-bombas',

      // Ocasional Client
      getOcasionalInformation: '/user/get-ocasional-information',
      updateInfoClientSelected: '/user/update-info-client-selected',
      createUserByAdmin: '/user-admin/create-update-user-by-admin',
      usersRelatedToAdmin: '/user-admin/users-related-to-admin',
      sendInvitationToRealtedAdmin: '/user-admin/send-invitation',
      enableUserAdmin: '/user-admin/enable-user-admin',
      permissionsFront: '/user-admin/get-permissions-front',
      preloadUserCreatedByAdmin: '/user-admin/preload-user-created-by-admin',

      // Consult
      getConsult: '/consult/get-consult',
      orderStatusReport: '/sincronizaciones/reportes-b-2-b/pedido-importado',
      referralsOrdersReport: '/sincronizaciones/reportes-b-2-b/remision-importada',

      // Consult
      getSucursales: '/login/get-sucursales-id-usuario',
      PROVIDER: {
        SCHEDULED_PAYMENTS: 'proveedores/pagos-programados/listar',
        FINISHED_PAYMENTS: 'proveedores/pagos-realizados/listar',
        CREDIT_NOTES: 'proveedores/notas-credito/listar',
      },
      PAYMENT_ADVANCED:{
        QUOTATIONS_HEAD: 'recaudos/crm/cabeceracot',
        QUOTATIONS_DETAIL: 'recaudos/crm/detallecot',
        ORDERS_SERVICE_HEAD: 'recaudos/crm/cabeceraordenes',
        ORDERS_SERVICE_DETAIL: 'recaudos/crm/detalleordenes'
      },
      PQRS: {
        PARAMS: 'pqrs/get-params',
        SAVE: 'pqrs/save-pqrs',
        LIST: 'pqrs/get-pqrs-list',
        DETAIL: 'pqrs/get-pqrs-detail',
        SAVE_RESPONSE: 'pqrs/save-pqrs-response',
        RESOLVED: 'pqrs/resolve-pqrs',
        CHANGE_STATUS: 'pqrs/change-status',
        RESPONSABLES_LIST: 'pqrs/get-responsable-pqrs-list?search=',
        CHANGE_PQRS_RESPONSABLE :'pqrs/change-responsable-pqrs',
        EXPORT_CSV: 'pqrs/exportar-incidencias-listado-csv',
        EXPORT_CSV_DETAIL: 'pqrs/exportar-incidencia-csv'
      },
      REPORTS: {
        // SYNC: {
        //   ORDER: {
        //     STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado'
        //   },
        //   REMISSION: {
        //     LIST: '/sincronizaciones/reportes-b-2-b/remision-importada'
        //   }
        // },
        SYNC: {
          ORDER: {
            STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado'
          },
          REMISSION: {
            LIST: '/sincronizaciones/reportes-b-2-b/remision-importada'
          },
          BILLFOLD: {
            LIST: "/sincronizaciones/reportes-b-2-b/cartera-importada",
          }
        },
        B2B: {
          CLIENT: "/sincronizaciones/reportes-b-2-b/cliente",
          ORDERS: "/sincronizaciones/reportes-b-2-b/pedidos-cliente",
          CONSOLIDATED: "/sincronizaciones/reportes-b-2-b/consolidados-cliente", // TODO: DELETE
          //BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente", // TODO: DELETE
          CONSOLIDATED_SMARTB: "/sincronizaciones/reportes-b-2-b/consolidados-cliente-smart-b",
          // BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente",
          BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/reporte-cartera-cliente"
        }
      },
      PRODUCTS: {
        LAST_ITEMS_BOUGHT: '/item-info/get-last-items-bought'
      }
    }
  },
  site : {
    config: {
      // Bandera para depuración del sitio. Muestra cierta información como
      // liquidación de transporte, etc.
      debug: false,
      showLegalAdvice: false,
      redirectToB2bPage: true,
      quantity_validate : false,
      data: {
        item: {
          // Muestra los comentarios en la canasta
          showComments: false,
          // Habilitación del filtro de precios en el listado de productos de unsa categoría
          showItemsPriceFilter: true,
          // Texto utilizado para el 'Precio en Internet'
          internetPriceString: 'Precio',
          annexedDocumentString: 'Ficha Técnica',
          getMoreSelledProducts: false,
          getNewProducts: false,
          getJoyasDeLaCasaProducts: false,
          placeholderSearchProduct: ''
        },
        shipping: {
          // Habilita la búsqueda rápida. No utilizar.
          fastSearch: true,
          // Muestra el punto de venta en la canasta.
          showPointsOfSale: false,
          // Muestra la forma de entrega en la canasta
          showShippingMethod: false,
          // Muestra el banner de entrega en la canasta. Este se debe utilizar cuando
          // se ocultan los dos parámetros: showPointsOfSale, showShippingMethod
          showBannerShippingMethod: true
        },
        cart: {
          cartBuyText: 'Confirmar pedido',
          // Mostrar comentario de la orden
          showOrderComment: true,
          maxlengthOrderComment: 60,
          // Mostrar simulación de cupon
          showDiscountCoupon: false,
          // Mostrar precio de transporte
          showTransportPrice: true,
          // mostrar boton de pdf
          showPdfButton: false,
          // mostrar mensaje 'TENER PRESENTE'
          showPremessageOrder: false,
          showSelectPriceList: false,
          showFooterCartBanner: false,
          showCartetera: false
        },
        tunnel: {
          // Mostrar fecha programada de entrega
          showContactProgrammedDelivery: true,
          // Utilizar pasarela
          hasGangway: true,
          // Permite realizar cotizaciones sin estar logueado
          allowQuotesNoLogin: true
        },
        banners: {
          // Mostrar banners de noticias. Essto fue una prueba.
          showNews: false
        },
        categories: {
          // Tipos de Menu:
          // 1. Con campo de filtro
          // 2. Slider a 2 niveles
          // 3. Slider multinivel
          menuType: 2,
          textOurProducts: ""
        },
        register: {
          // Login automático o no
          automaticLogin: true,
          allowRegister: false
        }
      },
      header: {
        showIcons : false,
        show_account_in_header : true,
        selectBranch : false,
        show_cart_in_header : false,
        showCategories : false,
        showKnowUs : false,
        showOfferts : false,
        showContact : true,
        show_tab_right : false,
        show_pay_zone : true,
        pay_zone : {
          pay_zone_and_advances : true,
          only_pay_zone : false,
          only_advances : false,
          only_payments : false
        },
        logout : {
          state_lost_session : 'home.login'
        },
        fastLoad : {
          showFastLoad : false
        }
      },
      footer : {
        is_template : false,
        template :  ``,
        options_list : [
          {

          }
        ],
        products : {
          show : true,
          text_describe : 'Productos',
          is_state : false,
          url_state : ''
        }
      },
      pay_zone : {
        home_url: 'home.detailZone',
        payments_url: 'home.myPaymentsList'
      },
      login : {
        // text_welcome_withow_branch: 'Las credenciales de acceso son validas. En un momento la página se recargara y tendra acceso a su cuenta.',
        text_welcome_withow_branch: 'Los datos de acceso son correctos, bienvenido a nuestra tienda virtual.',
        text_welcome_with_branch: 'Las credenciales de acceso son validas. Seleccione la sucursal con la que desea realizar las compras.'
      },
      // Panel de control del usuario
      dashboard: {
        // Mostrar las ordenes
        showMyOrders: true,
        // Mostrar las cotizaciones
        showMyQuotes: true,
        // Mostrar ver mi cuenta. Aquí se realiza la actualización de los datos.
        showMyAccount: true,
        // Mostrar cliente seleccionado. Dejar en 'false'.
        showSelectClient: true
      },
      menu: {
        // Mostrar menu de Incidencias
        showPqrs: false,
        // Mostrar menu de consultas B2B
        showConsults: false,
        // Mostrar menu corporativo
        showCoorporateDemoMenu: false,
        // mostrar enlace de búsqueda de trabajo
        showSearchJob: false,
        // Mostrar búsqueda dentro del menu
        showSearchInsideMenu: false,
        // Mostrar enlace de búsqueda rápida en el menu del footer. Si
        // se deja en 'true' el enalce se muestra en el menu del header.
        showFastLoadInHeader: false,
        showFastLoadInFooter: false,
        showFastLoadAlways: false,
        fastLoadText: 'Carga rápida'
      }
    },
    app: {
      url: 'https://www.pallomaro.com/tienda/',
      title: 'Diamante',
      description: 'Descripción el diamante',
      header: {
        showContactInfo: true,
        placeholder: 'Buscar',
        logo: {
          src: './assets/img/proyect-selected/logo-header.png',
          url: 'home.home',
          url_url: '/app/home',
          // url: 'https://www.pallomaro.com/tienda/#/',
          title: 'Diamante',
          alt: 'Diamante',
          width: '150px',
          height: 'auto'
        }
      },
      pages: {
        corporate: {
          link: {
            url: 'home.knowUs',
            title: 'Diamante'
          }
        }
      },
      footer: {
        menu: {
          contactUrl: 'home.contact'
        },
        info: {
          title: '',
          description: 'Trabajamos con excelencia y motivación para que cada día podamos garantizar el bienestar que trae ambientes sanos y limpios; entregar los mejores procesos y productos; brindar una atención cálida y eficaz, y asegurando el cuidado del medio ambiente.',
          date: new Date()
        },
        logo: {
          src: './assets/img/proyect-selected/logo-footer.png',
          title: 'Diamante',
          alt: 'Diamante',
          width: '190px',
          height: 'auto'
        },
        showNewsletterForm: false
      },
    },
    info: {
      company: {
        name: 'DIAMANTE',
        nit: '', // TODO
        webpage: '', // TODO
        address: 'Calle 4B No. 38-17',
        pbx: '(2) 514 7777',
        phone: '',
        cell: '',
        email: 'asistenteoperativo3@diamante.com.co',
        location: 'CALI'
      },
      social: {
        facebook: {
          title: 'Síguenos en facebook',
          link: 'https://www.facebook.com/brilladoraeldiamante/',
          alt: 'Facebook',
          show: true
        },
        youtube: {
          title: 'Véanos en youtube',
          link: 'https://www.youtube.com/user/6136465?sub_confirmation=1',
          alt: 'Youtube',
          show: false
        },
        twitter: {
          title: 'Twitter Diamante',
          link: 'https://twitter.com/Diamante1955',
          alt: 'Twitter',
          show: true
        },
        pinterest: {
          title: 'Pinterest Diamante',
          link: 'https://www.pinterest.com/davidsoul69/Diamante-valoramos-la-alimentaci%C3%B3n/',
          alt: 'Pinterest',
          show: false
        },
        linkedin: {
          title: 'Linkedin Diamante',
          link: 'https://www.linkedin.com/company-beta/10323386',
          alt: 'Twitter',
          show: true
        },
        instagram: {
          title: 'Instagram Diamante',
          link: 'https://www.instagram.com/Diamante/',
          alt: 'Instagram',
          show: false
        }
      },
      /*
      video: {
        link: 'https://www.youtube.com/embed/hq7ZrUQN1ZY'
      },
      imagenvideo: {
        idvideo: 'http://img.youtube.com/vi/hq7ZrUQN1ZY/0.jpg'
      },
      */
      recaptcha: {
        id: '6LfbIwsTAAAAAKhEWIKXphwD_Qa26r0_xl5E0Yon'
      }
    }
  }
};

export default constants;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/app.constants.js
 **/